@if(isLoader) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="'Procesando'"></app-loader>
  </div>
}

<div class="p-6">
  <!-- ===== STEP 1: SELECT DEVICE ===== -->
  @if(!isChoice) {
    <div class="flex flex-wrap items-center justify-between gap-3 mb-4">
      <p-iconfield>
        <p-inputicon styleClass="pi pi-search" />
        <input pInputText type="text" [(ngModel)]="searchText" placeholder="Buscar dispositivo..." (keyup)="searchByText($event)" class="w-full sm:w-72" />
      </p-iconfield>
      @if(filteredTable.length > 0 && searchText.trim()) {
        <span class="text-sm text-vivid-royal-400">{{ filteredTable.length }} dispositivos encontrados</span>
      }
    </div>

    <!-- Desktop -->
    <div class="hidden md:block">
    <p-table [value]="filteredTable" [paginator]="filteredTable.length > 12" [rows]="12"
      styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="flex"
      [showCurrentPageReport]="true" [currentPageReportTemplate]="'Mostrando {first} a {last} de {totalRecords}'">
      <ng-template #header>
        <tr>
          <th>Dispositivo</th>
          <th>Usuario</th>
          <th>Descripción</th>
          <th>Placas</th>
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr class="cursor-pointer hover:bg-vivid-royal-50 dark:hover:bg-vivid-royal-900" (click)="selectDevice(item)">
          <td class="font-semibold">{{ item.vehicleFullNumber }}</td>
          <td>{{ item.nameUser }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.plates }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr><td colspan="4" class="text-center py-8 text-vivid-royal-400">No hay dispositivos por visualizar</td></tr>
      </ng-template>
    </p-table>
    </div>

    <!-- Mobile -->
    <div class="md:hidden space-y-3">
      @for(item of filteredTable; track item.cardId) {
        <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-4 space-y-1 cursor-pointer active:bg-vivid-royal-50 dark:active:bg-vivid-royal-900" (click)="selectDevice(item)">
          <div class="flex items-center justify-between">
            <span class="font-bold text-vivid-royal-800 dark:text-white">{{ item.vehicleFullNumber }}</span>
            <i class="pi pi-chevron-right text-vivid-royal-300 text-sm"></i>
          </div>
          <div class="grid grid-cols-2 gap-x-4 text-sm">
            <span class="text-vivid-royal-400">Usuario</span>
            <span class="text-right text-vivid-royal-900 dark:text-white">{{ item.nameUser }}</span>
            <span class="text-vivid-royal-400">Placas</span>
            <span class="text-right text-vivid-royal-900 dark:text-white">{{ item.plates }}</span>
          </div>
        </div>
      }
      @if(filteredTable.length === 0) {
        <p class="text-center py-8 text-vivid-royal-400">No hay dispositivos por visualizar</p>
      }
    </div>
  }

  <!-- ===== STEP 2: ASSIGN DRIVERS ===== -->
  @if(isChoice) {
    <div class="space-y-4">
      <!-- Context header -->
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div class="flex items-center gap-3">
          <button pButton icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="back()"></button>
          <div class="w-10 h-10 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center">
            <i class="pi pi-credit-card text-vivid-royal-500 dark:text-vivid-royal-300"></i>
          </div>
          <div>
            <p class="text-sm font-semibold text-vivid-royal-700 dark:text-white">{{ selectedDevice?.vehicleFullNumber }}</p>
            <p class="text-xs text-vivid-royal-400 dark:text-vivid-royal-200">{{ selectedDevice?.nameUser }} · {{ selectedDevice?.plates }}</p>
          </div>
        </div>
        <div class="flex flex-wrap items-center gap-2">
          @if(isAdmin && hasAssignedDrivers) {
            <button pButton type="button" icon="pi pi-qrcode" [label]="allGenQR ? 'Deshabilitar QR todos' : 'Habilitar QR todos'"
              class="p-button-sm p-button-outlined" (click)="allGenQR=!allGenQR; changeAllQR(allGenQR)"
              pTooltip="Habilitar/deshabilitar generación de QR móvil para todos los conductores asignados"></button>
          }
          @if(dataResult.length > 0) {
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-sm p-button-outlined" (click)="cancel()"></button>
            <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" (click)="save()"></button>
          }
        </div>
      </div>

      <!-- Search + select all -->
      <div class="flex flex-wrap items-center justify-between gap-3">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" [(ngModel)]="searchText" placeholder="Buscar conductor..." (keyup)="searchByDrivers($event)" class="w-72" />
        </p-iconfield>
        @if(isAdmin && drivers.length > 0) {
          <button pButton [label]="isChecked ? 'Deseleccionar todos' : 'Seleccionar todos'" class="p-button-sm p-button-text" (click)="selectAll()"></button>
        }
      </div>

      <!-- Drivers desktop table -->
      <div class="hidden md:block">
      <p-table [value]="drivers" [paginator]="drivers.length > 20" [rows]="20"
        styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="450px">
        <ng-template #header>
          <tr>
            <th class="w-[50px]"></th>
            <th class="w-[50px]"></th>
            <th>Nombre</th>
            <th>Teléfono</th>
            @if(isAdmin) { <th class="w-[140px] text-center">QR Móvil</th> }
          </tr>
        </ng-template>
        <ng-template #body let-driver>
          <tr class="cursor-pointer" (click)="select(driver)"
            [ngClass]="{'bg-vivid-royal-50 dark:bg-vivid-royal-900': driver.type === 1 || driver.type === 2}">
            <td class="text-center">
              @switch(driver.type) {
                @case(0) { <i class="pi pi-circle text-gray-300 text-lg"></i> }
                @case(1) { <i class="pi pi-check-circle text-green-500 text-lg"></i> }
                @case(2) { <i class="pi pi-check-circle text-mustard-700 dark:text-mustard-400 text-lg"></i> }
                @case(4) { <i class="pi pi-times-circle text-red-400 text-lg"></i> }
              }
            </td>
            <td>
              <app-avatar [name]="driver.name" size="sm" [photoUuid]="driver.photo_uuid || null" />
            </td>
            <td class="font-medium">{{ driver.name }}</td>
            <td>{{ driver.phone_number }}</td>
            @if(isAdmin) {
              <td class="text-center" (click)="$event.stopPropagation()">
                @if(driver.type === 1 || driver.type === 2) {
                  <button pButton type="button" icon="pi pi-qrcode"
                    class="p-button-rounded p-button-sm"
                    [class.p-button-success]="driver.is_qr_enabled"
                    [class.p-button-secondary]="!driver.is_qr_enabled"
                    [class.p-button-outlined]="!driver.is_qr_enabled"
                    [pTooltip]="driver.is_qr_enabled ? 'QR móvil habilitado — click para deshabilitar' : 'QR móvil deshabilitado — click para habilitar'"
                    (click)="toggleQR(driver)">
                  </button>
                }
              </td>
            }
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr><td [attr.colspan]="isAdmin ? 5 : 4" class="text-center py-8 text-vivid-royal-400">No hay conductores por visualizar</td></tr>
        </ng-template>
      </p-table>
      </div>

      <!-- Drivers mobile cards -->
      <div class="md:hidden space-y-2">
        @for(driver of drivers; track driver.driver_id) {
          <div class="bg-white dark:bg-crayola-blue-800 rounded-lg shadow-sm p-3 flex items-center gap-3 cursor-pointer"
            [ngClass]="{'ring-2 ring-green-400': driver.type === 1, 'ring-2 ring-mustard-500': driver.type === 2, 'ring-2 ring-red-300': driver.type === 4}"
            (click)="select(driver)">
            <div class="shrink-0">
              @switch(driver.type) {
                @case(0) { <i class="pi pi-circle text-gray-300 text-lg"></i> }
                @case(1) { <i class="pi pi-check-circle text-green-500 text-lg"></i> }
                @case(2) { <i class="pi pi-check-circle text-mustard-700 text-lg"></i> }
                @case(4) { <i class="pi pi-times-circle text-red-400 text-lg"></i> }
              }
            </div>
            <app-avatar [name]="driver.name" size="sm" [photoUuid]="driver.photo_uuid || null" />
            <div class="flex-1 min-w-0">
              <p class="font-semibold text-sm text-vivid-royal-800 dark:text-white truncate">{{ driver.name }}</p>
              <p class="text-xs text-vivid-royal-400">{{ driver.phone_number }}</p>
            </div>
            @if(isAdmin) {
              <div (click)="$event.stopPropagation()" class="shrink-0">
                @if(driver.type === 1 || driver.type === 2) {
                  <button pButton type="button" icon="pi pi-qrcode"
                    class="p-button-rounded p-button-sm"
                    [class.p-button-success]="driver.is_qr_enabled"
                    [class.p-button-secondary]="!driver.is_qr_enabled"
                    [class.p-button-outlined]="!driver.is_qr_enabled"
                    (click)="toggleQR(driver)">
                  </button>
                }
              </div>
            }
          </div>
        }
        @if(drivers.length === 0) {
          <p class="text-center py-8 text-vivid-royal-400">No hay conductores por visualizar</p>
        }
      </div>

      <!-- Legend -->
      <div class="flex flex-wrap gap-5 text-xs text-vivid-royal-400 pt-1 mt-2 pl-2">
        <span><i class="pi pi-check-circle text-green-500 mr-1 align-middle"></i> Asignado</span>
        <span><i class="pi pi-check-circle text-mustard-700 dark:text-mustard-700 mr-1 align-middle"></i> Por asignar</span>
        <span><i class="pi pi-times-circle text-red-400 mr-1 align-middle"></i> Por desasignar</span>
        <span><i class="pi pi-circle text-gray-300 mr-1 align-middle"></i> Disponible</span>
      </div>
    </div>
  }
</div>
